import React from "react"
import { canAll, canAny } from "../../auth/ability"
import { TPermission } from "../../auth/permissions"
import { useAbility } from "../contexts/AbilityContext"
import NotAuthorized from "../common/NotAuthorized"

export type AuthorizedProps = {
    anyOf?: TPermission[]
    allOf?: TPermission[]
    page?: boolean
    children?: React.ReactNode
}

/** Rechteprüfung für Seiten und Elemente: `allOf` = früher requiresAll, `anyOf` = früher requiresOneOf; ohne Recht `<NotAuthorized/>` (page) oder nichts. */
export const Authorized = ({ anyOf, allOf, page, children }: AuthorizedProps) => {
    const ability = useAbility()
    const isAuthorized = canAll(ability, allOf ?? []) && canAny(ability, anyOf ?? [])
    if (isAuthorized) return <>{children}</>
    return page ? <NotAuthorized /> : null
}
